<template>
  <div class="containerteu">
    <el-select v-model="rules.act" :placeholder="$t('message.请选择')" @change="selectchange" :popper-append-to-body='false' popper-class="setSelect" @visibleChange='changeindex'>
      <el-option v-for="item in oplist" :key="item.value" :label="item.label" :value="item.value">
      </el-option>
    </el-select>
    <el-select v-model="rules.opeation" :placeholder="$t('message.请选择')" v-if="rules.act!==''" @change="handleChange" :key="rules.act" :popper-append-to-body='false' @visible-change='changeindex'>
      <el-option v-for="item in oplist2" :key="item.value" :label="$t('message.'+item.label)" :value="item.value">
      </el-option>
    </el-select>

    <el-input v-model="input" v-if="(rules.opeation!=5&&rules.opeation!=6&&rules.opeation!=8&&rules.opeation!=9&&rules.opeation!=14)&&rules.opeation&&typese!=2" @change="selchange(0)"></el-input>
    <span style="margin-left: 10px;"  v-if="rules.opeation==7&&typese!=2">{{$t('message.至')}}</span>
    <el-input v-model="input1" v-if="rules.opeation==7&&typese!=2" @input="selchange(1)"></el-input>
    <el-date-picker v-model="input" @change="selchange(0)" v-if="(rules.opeation!=5&&rules.opeation!=6&&rules.opeation!=14)&&rules.opeation&&typese==2" type="date" style="width:200px" value-format='timestamp' :placeholder="$t('message.选择日期时间')">
    </el-date-picker>
    <span style="margin-left: 10px;" v-if="rules.opeation==7&&typese==2">{{$t('message.至')}}</span>
    <el-date-picker v-model="input1" type="date" value-format='timestamp' v-if="rules.opeation==7&&typese==2" @change="selchange(1)" style="width:200px" :placeholder="$t('message.选择日期时间')">
    </el-date-picker>
    <div v-if="rules.opeation==14&&typese==2">
      <span>{{$t('message.在')}}</span>
      <el-input v-model="input"  @input="changemy" ></el-input>
      <span>{{$t('message.天')}}</span>
      <el-select v-model="input1" :placeholder="$t('message.请选择')" @change="rules.limit[1]=input1" :popper-append-to-body='false' @visible-change='changeindex'>
        <el-option v-for="item in optdata" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
    </div>
  </div>

</template>
<script>
  import { rejecthttp, changeflagCLOSED } from "@/utils/request";
  import { PopupManager } from 'element-ui/lib/utils/popup'

  export default {
    name: 'inputdata',
    props: ['rules', 'databasetype'],
    data() {
      return {
        options: [{
          value: 1,
          label: '等于',
        }, {
          value: 2,
          label: '不等于',
        }, {
          value: 3,
          label: '大于',
        }, {
          value: 4,
          label: '小于',
        }, {
          value: 5,
          label: '有值',
        }, {
          value: 6,
          label: '没值',
        }, {
          value: 7,
          label: '区间',
        }, {
          value: 8,
          label: '真',
        }, {
          value: 9,
          label: '伪',
        }, {
          value: 10,
          label: '包含',
        }, {
          value: 11,
          label: '不包含',
        }, {
          value: 12,
          label: '属于',
        }, {
          value: 13,
          label: '不属于',
        }, {
          value: 14,
          label: '当前时间点',
        }],
        value: '',
        value1: '',
        input: '',
        input1: '',
        input2: 1,
        oplist: [],
        // 类型表
        sytype: {
          0: [1, 2, 3, 4, 5, 6, 7, 12, 13],
          1: [1, 2, 5, 6, 10, 11, 12, 13],
          2: [1, 3, 4, 5, 6, 7, 14],
          3: [1, 2, 3, 4, 5, 6, 7, 12, 13],
          4: [5, 6, 8, 9],
          5: [1, 2, 3, 4, 7],
        },
        oplist2: [],
        typese: -1,
        optdata: [{ value: 0, label: '以内' }, { value: 1, label: '以外' }]
      }
    },
    methods: {
      changemy(){
        console.log(this.input)
        if(this.input<0){
          this.input=0
          this.rules.limit[0]=0
        }else{
          if(this.input===''){
            this.rules.limit[0]=''
          }else{
          this.rules.limit[0]=this.input-0
          }
        }
        console.log(this.rules.limit[0])
        // input<0?input=0:rules.limit[0]=input-0
      },
      changeindex(i) {
        console.log(i)
        // if (i) {
        //   PopupManager.zIndex = 6000
        // } else {
        //   PopupManager.zIndex = 2000
        // }
      },
      selchange(index) {
        console.log(this.input, this.input1)
        // console.log(this.rules.opeation);
        // console.log(this.typese);
        // console.log(index);
        // console.log(456758);
        if (this.rules.opeation == 12 || this.rules.opeation == 13) {
          this.rules.limit[0] = this.input.split(',')
          if (this.typese == 0 || this.typese == 5 || this.typese == 3) {
            this.rules.limit[0].forEach((item, index) => {
              this.rules.limit[0][index] = this.rules.limit[0][index] - 0
            })
          } else {}
        } else {
          if (this.typese == 0 || this.typese == 5 || this.typese == 3) {
            if (index == 0 && this['input']) {
              this.rules.limit[index] = this['input'] - 0
              console.log(typeof this.rules.limit[index]);
            } else if (index == 0 && !this['input']) {
              this.rules.limit[index] = this['input']
            } else if (index != 0 && this['input1']) {
              this.rules.limit[index] = this['input1'] - 0

            } else if (index != 0 && !this['input1']) {
              this.rules.limit[index] = this['input1']
            }
          } else {
            if (index) {
              this.rules.limit[index] = this['input' + index]
              console.log(typeof this.rules.limit[index]);
            } else {
              this.rules.limit[index] = this['input']
              console.log(typeof this.rules.limit[index]);
            }
          }
        }

      },
      handleChange() {
        this.rules.limit = []
        this.input = ''
        this.input1 = ''
        // this.input2=1
        // if(this.rules.opeation==14){
        //   this.rules.limit[0]=1
        //   this.rules.limit[1]=0
        // }
      },
      selectchange(e) {
        console.log(e);
        this.oplist2 = []
        this.rules.opeation = ''
        this.rules.limit = []
        this.input = ''
        this.input1 = ''
        let c = this.oplist.find(item => item.value == e)
        console.log(c);
        this.typese = c.type
        this.sytype[c.type].forEach(item => {
          this.oplist2.push(this.options[item - 1])
        })
      },
      getInit(){
        console.log(this.databasetype)
      try {
        let c
        if (!window.sessionStorage.getItem('fieldlist')) {
          rejecthttp(false, 'get', "/manage/metadata/getfieldlistbyapp", {
            appid: 188,
          }, this, (doc) => {
            changeflagCLOSED(doc, 0, this)
            if (doc.data.Code == "MSGKEY_OK") {
              console.log(doc.data);
              window.sessionStorage.setItem('fieldlist', JSON.stringify(doc.data.data))
              c = doc.data.data
              this.oplist = []
              c.forEach(it => {
                if (it.targettable == this.databasetype) {
                  this.oplist.push({ value: it.fieldid, label: it.name, labeleng: it.fieldname, type: it.attrgenre, comment: it.comment })
                }
              });
            }
          })
        } else {
          c = JSON.parse(window.sessionStorage.getItem('fieldlist'));
          this.oplist = []
          c.forEach(it => {
            if (it.targettable == this.databasetype) {
              this.oplist.push({ value: it.fieldid, label: it.name, labeleng: it.fieldname, type: it.attrgenre, comment: it.comment })

            }
          });
        }
        console.log(this.rules);
        let h = this.oplist.find(item => item.value == this.rules.act)
        console.log(h);
        this.typese = h.type
        this.sytype[h.type].forEach(item => {
          this.oplist2.push(this.options[item - 1])
        })
        console.log(this.oplist);
        if (this.rules.limit.length == 2) {
          console.log(this.rules.limit)
          this.input = this.rules.limit[0]
          this.input1 = this.rules.limit[1]
        } else if (this.rules.limit.length == 1) {
          this.input = this.rules.limit[0]
        }
      } catch (e) {
        console.log(e);
      }
      }
    },
    created() {
      this.getInit()
    },
    destroyed() {
      // PopupManager.zIndex = 2000
      // window.sessionStorage.setItem('input1h',this.input)
      // window.sessionStorage.setItem('input2h',this.input1)
    }
  }
</script>
<style scoped>
  .setSelect {
    z-index: 9000;
  }

  .containerteu {
    display: flex;
    justify-content: flex-start;
    line-height: 50px;
  }

  .el-select /deep/ .el-input {
    margin-left: 15px;
    width: 150px;

  }

  .el-input /deep/ {
    margin-left: 15px;
    width: 150px;
  }
</style>


// WEBPACK FOOTER //
// src/components/children/input.vue